module.exports.noop = function noop() {};